import React from 'react'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Save from '@material-ui/icons/Save';
import LinearProgress from '@material-ui/core/LinearProgress';

import { styles } from './styles';

function SaveForm (props) {
    const { form, classes } = props;
    const dialogState = props.dialogs[props.dialogName];

    if (!form) return null;

    return (
        <Dialog
            open={dialogState.open}
            fullWidth
        >
            <div className={classes.header}>
                <Typography variant="h6" color="inherit">
                    <Save className={classes.icon} />
                    Saving Form...
                </Typography>
            </div>
            <DialogContent className={classes.content}>
                <Typography variant="subtitle2" className={classes.formName}>{form.name}</Typography>
                <LinearProgress />
                <Typography className={classes.subText}>This might take a few seconds...</Typography>
            </DialogContent>
        </Dialog>
    );
}

const mapStateToProps = (state) => ({
    form: state.formEditor.form,
    dialogs: state.dialogs
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(SaveForm);
